export default __webpack_public_path__ + "static/media/incredible-kraver.43dc7144.svg";